export default class InstanceController {
    constructor(resource) {
      this._resource = resource;
    }
  
    refuel(refuel){
        return this._resource(`refuel`).save(refuel)
        .then(res=> res.body, err => {throw err})
    }
}
  